module.exports = __webpack_public_path__ + "static/assets/865309ebdabe1a08b6ae2a7fa8bc4cdf.png";